module.exports = __webpack_public_path__ + "img/otp.517ded3c.svg";